import { Controller } from 'stimulus'

import "vendor/timeago"

export default class TimeagoController extends Controller {
  connect() {
    $(this.element).timeago().tooltip()
  }
}